import OrderIndex from './OrderIndex';
import OrderCreate from './OrderCreate';
import OrderSettings from './OrderSettings';
import OrderSingle from './OrderSingle';
import ProductSettings from '../Product/ProductSettings';
import PaymentSettings from '../Payment/PaymentSettings';
import FormSettings from '../Form/FormSettings';
import FormFieldSettings from '../FormField/FormFieldSettings';
import FormEntrySettings from '../FormEntry/FormEntrySettings';
import ShopPayout from '../ShopPayout/ShopPayout';
import ShopPayoutSettings from '../ShopPayout/ShopPayoutSettings';

export default function (app) {

    const settings = OrderSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: "Shop",
        priority: 10,
        items: [
            {
                label: "Orders",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Products",
                path: ProductSettings.path,
                caps: ProductSettings.indexCaps
            },
            {
                label: "Payments",
                path: PaymentSettings.path,
                caps: PaymentSettings.indexCaps
            },
            {
                label: "Payouts",
                path: ShopPayoutSettings.path,
                caps: ShopPayoutSettings.indexCaps
            },
            {
                label: "Forms",
                path: FormSettings.path,
                caps: FormSettings.indexCaps
            },
            {
                label: "Form Fields",
                path: FormFieldSettings.path,
                caps: FormFieldSettings.indexCaps
            },
            {
                label: "Form Entries",
                path: FormEntrySettings.path,
                caps: FormEntrySettings.indexCaps
            }
        ],
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: "Actions",
        priority: 10,
        items: [
            {
                label: "Add New Order",
                path: settings.path + "/create",
                caps: settings.indexCaps
            },
            {
                label: "Add New Product",
                path: ProductSettings.path + "/create",
                caps: ProductSettings.createCaps
            },
            {
                label: "Add New Payout",
                path: ShopPayoutSettings.path + "/create",
                caps: ShopPayoutSettings.createCaps
            },
            {
                label: "Add News Form",
                path: FormSettings.path + "/create",
                caps: FormSettings.createCaps
            },
            {
                label: "Add New Form Field",
                path: FormFieldSettings.path + "/create",
                caps: FormFieldSettings.createCaps
            }
        ],
    });


    OrderIndex(app, settings);

    OrderCreate(app, settings);

    OrderSingle(app, settings);

}